import React from 'react'
import { Link, useHistory } from 'react-router-dom';
import profile from "../../../assets/images/profile.png";

const Phonemenuss = (props) => {
    return (
        <>
            <div className="phoneside d-lg-none d-block">
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0'>
                            <div className='head text-center'>
                                <h6>University</h6>
                                <div className='icon-Back'>
                                    <a><i class="fas fa-long-arrow-left"></i></a>
                                </div>
                            </div>
                            <div className='profile'>
                                <ul>
                                    <li>
                                        <Link to="/profile">
                                            <div className='useree'>
                                                <div className='left'>
                                                    <div className='user-img'>
                                                        <img src={profile} />
                                                    </div>
                                                </div>
                                                <div className='right'>
                                                    <div className='name'>
                                                        <p>Alex Molet</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/about-us">Admission</Link>
                                    </li>
                                    <li>
                                        <Link to="/privacy-policy">Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/contact-us">About us</Link>
                                    </li>
                                    <li>
                                        <Link to="/terms-conditions">Contact us</Link>
                                    </li>
                                    <li>
                                        <a>Logout</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}



export default (Phonemenuss);
